import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IntercityActions } from './actions/intercity.actions';

@NgModule({
    declarations: [],
    imports: [CommonModule],
    providers: [IntercityActions],
})
export class IntercityModule {}
